import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

export default class Services extends Component {
    render() {
        return (
            <Fragment>
                <h6 class="navbar-heading text-muted">Serviços</h6>
                <ul class="navbar-nav mb-md-3">
                    <li class="nav-item">
                        <Link class="nav-link" to="/ajuda">
                            <i class="ni ni-key-25"></i> Central de Ajuda
                        </Link>
                    </li>
                    <li class="nav-item">
                        <Link class="nav-link" to="/suporte">
                        <i class="ni ni-spaceship"></i> Suporte Técnico
                        </Link>
                    </li>
                </ul>   
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar/Services.js